import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { ChannelConfigStepper } from './ChannelConfigStepper';

export class TelegramStepper extends Component {

  static propTypes = {
    channel: PropTypes.object,
    channelType: PropTypes.string.isRequired,
    fetch: PropTypes.func.isRequired,
    createChannel: PropTypes.func.isRequired,
    goBack: PropTypes.func.isRequired
  }

  constructor(props,context) {
    super(props,context);
    this.handleNextStep = this.handleNextStep.bind(this);
  }

  handleNextStep() {
    const { stepper, state } = this.channelConfigStepper
    const step = stepper.state.activeStep
    if (step === 1) {
      this.nextStep()
    }
    if (step === 2) {
      if (this.props.addingChannel) {
        this.props.fetch('Fetch Telegram Bot', `https://api.telegram.org/bot${state.params.token}/getMe`, (response, err) => {
           if (!err && response.ok) {
             this.save(response.result)
           }
        })
      }
      else {
        this.nextStep()
      }
    }
  }

  nextStep() {
    if (this.channelConfigStepper.isLastStep()) {
      this.props.goBack()
    }
    else {
      this.channelConfigStepper.stepper.nextStep()
    }
  }

  save(bot){
    const { state } = this.channelConfigStepper
    let newChannel = {enabled: true}
    newChannel.params = {
      'bot_name': bot.username,
      'token': state.params.token
    }
    newChannel.title = bot.first_name

    this.props.createChannel(newChannel, (response, err) => {
      if (!err) {
        this.nextStep()
      }
    })
  }

  render(){
    const { channel, channelType } = this.props
    return (
      <div>
        <ChannelConfigStepper ref={(s) => this.channelConfigStepper = s} channel={channel} channelType={channelType} onBeforeNextStep={this.handleNextStep} />
      </div>
    )
  }

}



// WEBPACK FOOTER //
// ./src/containers/TelegramStepper.js